import React from 'react';
import ReactDOM from 'react-dom';
import $ from '../../../offline/jquery.min.js';
import { DragDropContext } from 'react-beautiful-dnd';

import DFBuilderForm from './Form';
import { DynamicFormScreenContextProvider, DynamicFormBuilderScreenContext } from '../../Context/DynamicFormContext';
import DraggableWidgetList from './DraggableWidgetList';
import ConfigService from '../../Services/api/Config';

import './style.scss';
import Spin from '../Common/Spin';
import InputSelect from '../FormFields/Select';
import classNames from 'classnames';
window.React = React;
window.ReactDOM = ReactDOM;

class _DynamicFormBuilderScreen extends React.PureComponent {
  state = {
    isDraggingSection: false,
    isDraggingField: false,
    indexOrigin: null,
    indexDestination: null,
    originId: null,
    destinationId: null,
    sectionsCollapsable: {},
    dragElementHeight: 0,
    created_in_language: this.props.df.created_in_language ? this.props.df.created_in_language : this.props.preferredLanguage,
    translations : this.props.df.languages ? this.props.df.languages : [],
    updated_in_language : this.props.isEdit ? this.props.df.updated_in_language ? this.props.df.updated_in_language : this.props.df.created_in_language ? this.props.df.created_in_language.code : null : null
  };

  UNSAFE_componentWillMount() {
    const { df, submissionCallback, configTheme, accountPermissions, accountUserPermissions, isAdmin, availableLanguages, preferredLanguage, isEdit } = this.props;
    ConfigService.updateConfig(configTheme);
    this.context.api.init(df, submissionCallback, accountPermissions, accountUserPermissions, isAdmin, availableLanguages, preferredLanguage, isEdit, this.state.updated_in_language);
  }

  componentDidMount() {
    try {
      const inIframe = window.self !== window.top;
      if (inIframe) {
        document.documentElement.classList.add('in-iframe');
      }
    } catch (e) {
      document.documentElement.classList.add('in-iframe');
    }
  }

  collapseAll = () => {
    const { data } = this.context;
    const { sectionsCollapsable } = this.state;
    data.sections.order.map(sectionId => sectionsCollapsable[sectionId] = true);
    this.setState({
      sectionsCollapsable
    });
    this.context.api.onDFUpdateData();
  };

  expandAll = () => {
    this.setState({
      sectionsCollapsable: {}
    });
    this.context.api.onDFUpdateData();
  };

  collapseSection = (sectionId) => {
    const { sectionsCollapsable } = this.state;
    sectionsCollapsable[sectionId] = !sectionsCollapsable[sectionId];
    this.setState({
      sectionsCollapsable
    });
    this.context.api.onDFUpdateData();
  };

  onDragEnd = (result) => {
    const { api } = this.context;
    const { source, destination, draggableId } = result;

    this.setState({ isDraggingSection: false, isDraggingField: false, indexDestination: null, indexOrigin: null, originId: null, destinationId: null });

    if (!destination && source.droppableId !== 'droppable' && source.droppableId !== 'DraggableWidgetList') {
      const sourceSection = draggableId.split('-')[1];
      api.onRemoveField(source.index, sourceSection);
      return;
    }

    if (!destination && source.droppableId === 'droppable') {
      api.onRemoveSection(source.index);
      return;
    }

    if (!destination) return;

    if (source.droppableId === 'droppable') {
      if (destination.index === 0) return;
      api.onChangeSectionOrder(source.index, destination.index);
    }
    if (source.droppableId === 'DraggableWidgetList' && draggableId === 'sectionDivider') {
      if (destination.index === 0) return;
      api.onAddNewSection(destination.index, draggableId);
      return;
    }
    if (source.droppableId === 'DraggableWidgetList') {
      const destinationSectionIndex = destination.droppableId.split('-')[0];
      if (destinationSectionIndex === 'droppable') return;
      api.onAddNewField(destination.index, destinationSectionIndex, draggableId);
    } else {
      const sourceSection = draggableId.split('-')[1];
      const destinationSectionIndex = destination.droppableId.split('-')[0];
      if (destinationSectionIndex === 'droppable') return;
      api.onChangeFieldOrder(source.index, destination.index, sourceSection, destinationSectionIndex);
    }
  };

  onDragStart = (result) => {
    setTimeout(() => {
      const dragElement = $('#'+result.draggableId.split('#').join(''));
      if (result.source.droppableId === 'droppable' || result.draggableId === 'sectionDivider') {
        this.setState({
          isDraggingSection: true,
          isDraggingField: false,
          indexOrigin: result.source.index,
          originId: result.source.droppableId,
          destinationId: result.source.droppableId,
          dragElementHeight: dragElement.height()
        });
      } else {
        this.setState({
          isDraggingSection: false,
          isDraggingField: true,
          indexOrigin: result.source.index,
          originId: result.source.droppableId,
          destinationId: result.source.droppableId,
          dragElementHeight: dragElement.height()
        });
      }
    }, 10);

  };

  onDragUpdate = (result) => {
    if (result.destination && (this.state.isDraggingField || this.state.isDraggingSection)) {
      if ((this.state.indexDestination !== result.destination.index) || (this.state.destinationId !== result.destination.droppableId)) {
        this.setState({indexDestination: result.destination.index, destinationId: result.destination.droppableId} );
      }
    }
  };
  onCreateInLanguageUpdate = (v) => {
    const {modified} = this.context;
    if(!modified){
      this.setState({created_in_language : v})
      this.context.api.onDFBasicValueChange('created_in_language', v);
    }
    else{
      this.props.onAction().then(data =>{
        if(data){
          this.setState({created_in_language : v})
          this.context.api.resetDFData(v);
        }
      })
    }
  }
  onUpdateTranslationLanguage = (v) =>{
    this.setState({translations: v});
    this.context.api.onDFBasicValueChange('languages', v)
  }

  render() {
    const {availableLanguages, isEdit} = this.props;
    const {
      data,
      api,
      triggerTemplates,
      propertyFields,
      contactTypes,
      chargeCodes,
      pmsPlatforms,
      unitFields,
      sectors,
      clientInstances,
      loading,
      undo,
      localeCreated,
      tabs
    } = this.context;
    const {
      isDraggingSection,
      isDraggingField,
      indexDestination,
      indexOrigin,
      originId,
      destinationId,
      dragElementHeight,
      sectionsCollapsable,
      updated_in_language
    } = this.state;
    const styleRight = {
      'borderColor': ConfigService.getColor('primaryColor')
    };
    return (
      <>
      {(availableLanguages && availableLanguages.length > 0) && <div className="DFBuilderForm_Translations_parent" >
      <div className='DFBuilderForm_Translations'>
          <InputSelect label='Create Form' options={availableLanguages} value={this.state.created_in_language}
            onChange={v => this.onCreateInLanguageUpdate(v)} className='w-40'/>
          <InputSelect label='Display Languages' options={availableLanguages} value={this.state.translations} multiple = {true} className='w-40'
          onChange={v => this.onUpdateTranslationLanguage(v)}/>

        </div>
      </div>}
      {(availableLanguages && availableLanguages.length > 0 && isEdit && !localeCreated && tabs && tabs.length > 1) && <div className='Language Tabs'>
          {
            tabs.map((lang) => {
             return <div  key={lang.code} className={classNames('Language_LangTabs', {
              Language_LangTabs_Active: updated_in_language === lang.code
              })
              }
                onClick={() => {
                  this.context.api.onDFBasicValueChange('updated_in_language', lang.code)
                  this.setState({ updated_in_language: lang.code })
                }
                }>
                {lang.label}
              </div>
            })
          }
          </div>}
        <div className='DynamicFormBuilderScreen'>
          <DragDropContext onDragEnd={this.onDragEnd} onDragUpdate={this.onDragUpdate} onDragStart={this.onDragStart}>
            <div className='DynamicFormBuilderScreen_Left'>
              <DFBuilderForm formData={data} triggerTemplates={triggerTemplates} propertyFields={propertyFields}
                unitFields={unitFields} api={api} isDraggingSection={isDraggingSection} undo={undo}
                isDraggingField={isDraggingField} indexDestination={indexDestination} sectors={sectors}
                indexOrigin={indexOrigin} originId={originId} destinationId={destinationId}
                sectionsCollapsable={sectionsCollapsable} clientInstances={clientInstances} pmsPlatforms={pmsPlatforms}
                dragElementHeight={dragElementHeight} contactTypes={contactTypes} chargeCodes={chargeCodes}
                collapseAll={this.collapseAll} expandAll={this.expandAll} collapseSection={this.collapseSection} availableLanguages={availableLanguages}/>
            </div>
            <div className={`${availableLanguages && availableLanguages.length > 0 && isEdit && tabs && tabs.length > 0 && !localeCreated ? "DynamicFormBuilderScreen_RightWithLang" : "DynamicFormBuilderScreen_Right"}`} style={styleRight}>
              <DraggableWidgetList />
            </div>
          </DragDropContext>
      </div>
        { loading &&
          <Spin/>
        }
      </>
      
    );
  }
}

_DynamicFormBuilderScreen.contextType = DynamicFormBuilderScreenContext;

class DynamicFormBuilderScreen extends React.Component {
  render() {
    const { df, submissionCallback, configTheme, accountPermissions, accountUserPermissions, userData, availableLanguages, preferredLanguage, isEdit, onAction } = this.props;
    return (
      <DynamicFormScreenContextProvider>
        <_DynamicFormBuilderScreen
          df={ df }
          submissionCallback={ submissionCallback }
          configTheme={ configTheme }
          accountPermissions={ accountPermissions }
          accountUserPermissions={ accountUserPermissions }
          isAdmin={userData.isAdmin}
          availableLanguages = {availableLanguages}
          preferredLanguage= {preferredLanguage}
          isEdit = {isEdit}
          onAction = {onAction}
        />
      </DynamicFormScreenContextProvider>
    );
  }
}

window.DynamicFormBuilderScreen = DynamicFormBuilderScreen;